export type ContactFormValues = {
  id?: number;
  name: string;
  type: string;
  userName: string | null;
  password: string | null;
};

export enum TrackingProviders {
  'Macropoint' = 1,
  'TenFourSystems' = 2,
  'Project44' = 3,
  'FourKites' = 4,
  'Transflo' = 5,
  'Shippeo' = 6,
  'TruckerTools' = 7,
  'Transporeon' = 8,
}
